import { Wallet } from '@fanduel/cpe-um-bundle/wallet/library';
import { Balance } from '@fanduel/cpe-um-bundle/wallet/contract';
import { initializeUnifiedModules } from '../unified-modules-core';

export const getBalance = async (): Promise<Set<Balance> | null> => {
  await initializeUnifiedModules();
  return Wallet.getBalancesAsync();
};

export const depositFunds = async () => {
  await initializeUnifiedModules();
  await Wallet.depositFundsAsync();
};
